function buildDisplayName(firstname?: string, lastname?: string): string {
  if (!firstname && !lastname) return '';
  if (!firstname) return lastname || '';
  if (!lastname) return firstname || '';

  return `${firstname} ${lastname}`;
}

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@features/ui';
import { cn } from '@lib/utils';
import { MenuIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetMe } from '@hooks/useGetMe.ts';
import { useAuth } from '@hooks/useAuth.ts';
import { AvatarHeader } from '@src/features/core/ui/layout/avatarHeader';

import IconDown from './IconDown';

const navItems = [
  {
    label: 'checkout.selectTradingPlatform.title',
    href: '/select-trading-platform',
  },
  {
    label: 'checkout.accountSize',
    href: '/select-account',
  },
  {
    label: 'checkout.addOns',
    href: '/add-ons',
  },
  {
    label: 'checkout.orderSummary',
    href: '/review-checkout',
  },
];

export const CheckoutLayout = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const { t } = useTranslation();
  const location = useLocation();
  const { me, loading } = useGetMe();
  const { logout } = useAuth();

  if (!me?.id && !loading) {
    return <Navigate replace={true} to={'/signin'} />;
  }

  return (
    <>
      <header className="flex justify-between items-center max-w-[1440px] mx-auto pt-6 lg:pt-9">
        <div
          className="flex justify-between flex-1 lg:px-[20px] items-center py-4 rounded-[10px]"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)' /* 10% = 0.1 opacity */,
            backdropFilter: 'blur(200px)',
          }}
        >
          <img alt="logo" src="/assets/logo.svg" />
          <nav className="hidden lg:flex items-center gap-x-[10px]">
            {/*{navItems.map((item) => (*/}
            {/*  <Button*/}
            {/*    key={item.label}*/}
            {/*    className="px-[10px] py-[12px] h-[44px] text-[16px]"*/}
            {/*    size={'lg'}*/}
            {/*    type={'submit'}*/}
            {/*    variant={*/}
            {/*      location.pathname.includes(item.href) ? 'gradient' : 'outline'*/}
            {/*    }*/}
            {/*  >*/}
            {/*    {t(item.label)}*/}
            {/*  </Button>*/}
            {/*))}*/}
            <div className="pl-[59px] pr-[30px] flex items-center gap-x-4">
              {/* <IconNotification /> */}
              <div className="flex items-center ml-[30px]">
                <AvatarHeader />
                <div className="ml-4 flex flex-col justify-center">
                  <span className="text-white text-[14px] font-semibold leading-none">
                    {buildDisplayName(me?.first_name, me?.last_name)}
                  </span>
                </div>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button className="cursor-pointer">
                      <IconDown className="ml-4" />
                    </button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent
                    align="end"
                    className="w-48 bg-[#1F2630] border-0"
                  >
                    <DropdownMenuItem onClick={logout}>
                      {t('dashboardMenuItems.logout')}
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </div>
          </nav>
        </div>
        <MenuIcon
          className="lg:hidden cursor-pointer"
          height={32}
          width={32}
          onClick={() => setOpenDrawer(true)}
        />
        <Sheet open={openDrawer} onOpenChange={setOpenDrawer}>
          <SheetContent className="gap-0 pt-14">
            {navItems.map((item) => (
              <SheetHeader
                key={item.label}
                className={cn(
                  location.pathname.includes(item.href) ? 'bg-accent' : ''
                )}
              >
                <SheetTitle className="hover:text-link">
                  <Link
                    className={cn(
                      'text-xl',
                      location.pathname.includes(item.href) ? 'text-link' : ''
                    )}
                    to={item.href}
                    onClick={() => setOpenDrawer(false)}
                  >
                    {t(item.label)}
                  </Link>
                </SheetTitle>
              </SheetHeader>
            ))}
          </SheetContent>
        </Sheet>
      </header>
      <Outlet />
    </>
  );
};
